import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  NAVBAR_OPEN,
  NAVBAR_CLOSE,
  NOTIFICATION_OPEN,
  NOTIFICATION_CLOSE,
  SET_AUTH_TOKENS,
  REFRESH_USER,
  SET_USER,
} from "../actions";

const nav_reducer = (state, action) => {
  if (action.type === SIDEBAR_OPEN) {
    return { ...state, isSidebarOpen: true };
  }
  if (action.type === SIDEBAR_CLOSE) {
    return { ...state, isSidebarOpen: false };
  }

  if (action.type === NAVBAR_OPEN) {
    return { ...state, isNavbarOpen: true };
  }
  if (action.type === NAVBAR_CLOSE) {
    return { ...state, isNavbarOpen: false };
  }

  if (action.type === NOTIFICATION_OPEN) {
    return { ...state, isNotificationOpen: true };
  }
  if (action.type === NOTIFICATION_CLOSE) {
    return { ...state, isNotificationOpen: false };
  }
  if (action.type === SET_AUTH_TOKENS) {
    return {
      ...state,
      accessToken: action.payload.accessToken,
      refreshToken: action.payload.refreshToken,
    };
  }
  if (action.type === REFRESH_USER) {
    /* console.log(`Reducer :: Refreshing user`);
    console.log(action.payload); */
    return {
      ...state,
      user: action.payload,
    };
  }
  if (action.type === SET_USER) {
    /* console.log(`Reducer :: saving user in the state`);
    console.log(action.payload); */
    return {
      ...state,
      user: action.payload,
    };
  }

  throw new Error(`Nav Reducer :: No Matching "${action.type}" - action type`);
};

export default nav_reducer;
